import VueCompiler from 'vue/dist/vue.esm.js'
const templateRender = (template, data, methods, other) => {
  let obj = {
    template: template,
    mixins: [],
    data: function () {
      return data
    },
    methods: methods
  }
  obj = Object.assign(obj, other)
  let newComp = new VueCompiler(obj)
  let tempComp = newComp.$mount()
  return tempComp.$el
}
export default {
  templateRender
}

